import { IStore } from '@aurelia/state';
import { lifecycleHooks, resolve } from 'aurelia';
import { IRouteViewModel, Params, RouteNode } from '@aurelia/router-lite';

import { ActionNames, UpdateOgType } from '../../state';

@lifecycleHooks()
export class OgHook {
    private readonly store: IStore<{}, UpdateOgType> = resolve(IStore);

    public loading(
        _viewmodel: IRouteViewModel,
        _params: Params,
        next: RouteNode
    ) {
        this.store.dispatch({ type: ActionNames.UPDATE_OG_TYPE, value: next.data?.ogType! as string });
    }
}
